import type { EntityOptions, UserDetail } from 'models';
// TODO: fix these imports - 82948, create member feature
import { CommunitiesSlider } from 'features/communities';
import { OrganizationsSlider } from 'features/organizations';
import { ProgramsSlider } from 'features/programs';
import { MemberAboutCard, MemberActions, MemberContentLayout, MemberProfileCard } from '../components';
import type { MemberEntityScope } from '../types';

type P = {
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
  member: UserDetail;
  navigateToMembersEntity: (id: string, scope: MemberEntityScope) => void;
};

const OtherMemberProfile = ({ getPathToEntityDetail, member, navigateToMembersEntity }: P) => (
  <MemberContentLayout
    left={
      <>
        <MemberProfileCard actions={<MemberActions member={member} />} member={member} />
        <MemberAboutCard member={member} />
      </>
    }
    right={
      <>
        <CommunitiesSlider
          colSpan={10}
          controls={{
            hasTitleIcon: true,
            seeAll: {
              onClick() {
                navigateToMembersEntity(member.id, 'communities');
              },
            },
            title: 'Joined communities',
            titleLevel: 4,
          }}
          getPathToCommunityDetail={(id) => getPathToEntityDetail(id, { entityType: 'community' })}
          query={{ filter: { featured: undefined, scope: 'joined', userId: member.id } }}
        />
        <OrganizationsSlider
          colSpan={10}
          controls={{
            hasTitleIcon: true,
            seeAll: {
              onClick() {
                navigateToMembersEntity(member.id, 'organizations');
              },
            },
            title: 'Joined organizations',
            titleLevel: 4,
          }}
          getPathToOrganizationDetail={(id) => getPathToEntityDetail(id, { entityType: 'organization' })}
          query={{
            filter: {
              scope: 'joined',
              userId: member.id,
            },
          }}
        />
        <ProgramsSlider
          colSpan={10}
          controls={{
            hasTitleIcon: true,
            seeAll: {
              onClick() {
                navigateToMembersEntity(member.id, 'programs');
              },
            },
            title: 'Joined programs',
            titleLevel: 4,
          }}
          getPathToProgramDetail={(id) => getPathToEntityDetail(id, { entityType: 'program' })}
          query={{ filter: { featured: undefined, scope: 'joined', userId: member.id } }}
        />
      </>
    }
  />
);

export default OtherMemberProfile;
